var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCouriersIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.724,
    height: 20.362,
    viewBox: "0 0 18.724 20.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "CouriersIcon",
    d: "M20,7.5,12,3,4,7.5m16,0v9L12,21M20,7.5,12,12m0,9L4,16.5v-9M12,21V12M4,7.5,12,12m4-6.75L8,9.75",
    transform: "translate(-2.638 -2)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouriersIconDark);
export default __webpack_public_path__ + "static/media/CouriersIconDark.b9a220948daf27b3d0decddeada6ff2b.svg";
export { ForwardRef as ReactComponent };